import React, { useState, useEffect } from "react";

function getSelect(attrName, values, selection, onChange) {
  return (
    <fieldset
      form="uiForm"
      id={attrName}
      value={selection ? selection : ""}
      onChange={e => onChange(e.target.value)}
    >
      {values.map(val => (
        <span key={val.get("value")}>
          <label for={val.get("value")}>{val.get("label")}</label>
          <input
            type="radio"
            id={val.get("value")}
            value={val.get("value")}
            name={attrName}
            checked={selection === val.get("value")}
          />
        </span>
      ))}
    </fieldset>
  );
}

const CompAttrEditView = ({ attr, attrValue, handleAttrChange }) => {
  let attrType = attr.get("type");
  if (attrType === "name" || attrType === "label" || attrType === "number") {
    return (
      <input
        type="text"
        value={attrValue}
        onChange={e => handleAttrChange(e.target.value)}
      />
    );
  } else if (attrType === "state") {
    return <div>SELECT STATE HERE</div>;
  } else if (attrType === "select") {
    let values = attr.get("selectValues");
    return (
      <div>
        {attr.get("name")}:{" "}
        {getSelect(attr.get("attr"), values, attrValue, handleAttrChange)}
      </div>
    );
  } else if (attrType === "ui-event") {
    console.log("attrType ui-event " + attrValue);
    return <div>UI-Event: {attrValue}</div>;
    //this.getUiEventSelect(attrName, attrValue, newValue =>
    //  this.handleAttrChange(attrName, newValue, isMultiAttr, index)
    //)
  } else if (attrType === "text") {
    return (
      <textarea
        form="uiForm"
        value={attrValue}
        onChange={e => handleAttrChange(e.target.value)}
      />
    );
  }
  return "";
};
export default CompAttrEditView;



// WEBPACK FOOTER //
// ./src/components/CompAttrEditView.js